
window.load = false;

function openSortBY() {
  const mobileSortPopup = document.querySelector('.usf-popover.desktop-none');
  mobileSortPopup.removeAttribute('aria-hidden');
}


function closeSortBY() {
  const mobileSortPopup = document.querySelector('.usf-popover.desktop-none');
  mobileSortPopup.setAttribute('aria-hidden', 'true');
}

function mobileSortItems(button) {
  const usfButtons = document.querySelectorAll('.usf-c-select__btn');
  const val = button.getAttribute('data-value');
  usfButtons.forEach(btn => btn.classList.remove('usf-selected'));
  button.classList.add('usf-selected');
  document.querySelectorAll('.sort-dropdown__option').forEach(opt => {
    if (opt.getAttribute('data-value') === val) {
      opt.click();
      document.querySelector('.usf-popover.desktop-none .usf-remove')?.click();
    }
  });

}

function collapseFilter(facet, event) {
  event.preventDefault();
  // toggleBtn?.addEventListener('click', () => {
  //   facet.classList.toggle('usf-collapsed');
  // });

  facet.closest('.usf-facet') ? facet.closest('.usf-facet').classList.toggle('usf-collapsed') : "";
}

function toggleGrid(btn) {
  const viewButtons = document.querySelectorAll('.view-toggle__button');
  viewButtons.forEach(b => b.classList.remove('is-active'));
  btn.classList.add('is-active');
  const selectedView = btn.getAttribute('data-usf-view');
  document.body.setAttribute('data-current-view', selectedView);
}

function checkedAll(btn) {
  btn.closest(".custom-open").querySelectorAll(".filter_list label").forEach(function (input) {
    input.click()
  })
}

function updateAllFilters(url, params) {
  if (params != "") {
    window.all_location = window.location.pathname + '?' + params;
  } else {
    window.all_location = url
  }

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('.product-grid');
      const currentGrid = document.querySelector('.product-grid');
      if (newGrid && currentGrid) currentGrid.innerHTML = newGrid.innerHTML;

      const newFilters = doc.querySelector('.all_active_filter');
      if (newFilters) document.querySelector('.all_active_filter').innerHTML = newFilters.innerHTML;
      // document.querySelector(".filter_box").innerHTML = doc.querySelector(".filter_box").innerHTML;
      history.replaceState({}, '', window.all_location);
      // updateCustomSliders()

      removeURLS()
    })
    .catch(err => console.error('Filter fetch failed:', err));
}

function removeURLS() {
  document.querySelectorAll(".filter_box a.active-filter-group__item").forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      var url = this.getAttribute("href")
      updateAllFilters(url, "");
    })
  })
}

removeURLS()

// ✅ AJAX Filters (FacetFiltersForm & SortByForm)

function applyAjaxFilters() {
  const filterForm = document.getElementById("FacetFiltersForm");
  const sortForm = document.getElementById("SortByForm");
  const sortInput = document.getElementById("SortByInput");
  const formData = new FormData(filterForm);
  if (sortInput) formData.append("sort_by", sortInput.value);
  const params = new URLSearchParams(formData).toString();
  console.log(params)
  updateAllFilters((window.location.pathname + '?' + params), params)
}

function applyAjaxFilters2() {
  const filterForm = document.getElementById("FacetFiltersForm2");
  const sortForm = document.getElementById("SortByForm");
  const sortInput = document.getElementById("SortByInput");
  const formData = new FormData(filterForm);
  if (sortInput) formData.append("sort_by", sortInput.value);
  const params = new URLSearchParams(formData).toString();
  console.log(params)
  updateAllFilters((window.location.pathname + '?' + params), params)
}


function updateFilterRange(min, max, slider) {
  if (slider.closest(".custom-slider-here") != null && window.load) {
    slider.closest(".custom-slider-here").previousElementSibling.querySelectorAll("input").forEach(function (input) {
      console.log(input);
      if (input.value >= parseInt(min.value) && input.value <= parseInt(max.value)) {
        input.checked = true;
      } else {
        input.checked = false;
      }
    })
  }
}

function updateCustomSliders() {
  document.querySelectorAll(".custom-slider-here").forEach(function (slide) {
    var arrayList = [];
    slide.previousElementSibling.querySelectorAll("input").forEach(function (input) {
      arrayList.push(parseInt(input.value))
    })
    slide.querySelector(".usf-slider-input__from input").value = arrayList[0];
    var space = arrayList[arrayList.length - 1] - arrayList[0];
    slide.querySelector(".usf-slider-input__to input").value = arrayList[arrayList.length - 1];
    slide.querySelectorAll(".usf-slider-pip__value")[0].textContent = arrayList[0];
    slide.querySelectorAll(".usf-slider-pip__value")[1].textContent = arrayList[0] + 0.33 * space;
    slide.querySelectorAll(".usf-slider-pip__value")[2].textContent = arrayList[0] + 0.66 * space;
    slide.querySelectorAll(".usf-slider-pip__value")[3].textContent = arrayList[arrayList.length - 1];
  })
}

function inputChange() {
  setTimeout(() => {
    if (window.innerWidth > 767) applyAjaxFilters();
  }, 500);
}


function mobileSubmit() {
  applyAjaxFilters2();
  document.querySelector("#customMainDrawer .usf-close").click();
}




// ✅ Drawer Functions
function customOpenDrawer() {
  document.getElementById('customMainDrawer').classList.add('custom-open');
  document.querySelector('.site-header-main').style.display = 'none';
  document.querySelector('#chatra').style.display = 'none';
}
function customOpenNestedDrawer(button) {
  const nestedDrawer = button.nextElementSibling;
  if (nestedDrawer?.classList.contains('custom-nested-drawer')) {
    nestedDrawer.classList.add('custom-open');
    document.querySelector('.site-header-main').style.display = 'none';
    document.querySelector('#chatra').style.display = 'none';
  }
}
function customCloseNestedDrawer(button) {
  const nestedDrawer = button.closest('.custom-nested-drawer');
  if (nestedDrawer) {
    nestedDrawer.classList.remove('custom-open');
    document.querySelector('.site-header-main').style.display = 'none';
    document.querySelector('#chatra').style.display = 'none';
  }
}
function customCloseDrawer() {
  document.getElementById('customMainDrawer').classList.remove('custom-open');
  document.querySelectorAll('.custom-nested-drawer').forEach(drawer =>
    drawer.classList.remove('custom-open')
  );
  document.querySelector('.site-header-main').style.display = 'flex';
  document.querySelector('#chatra').style.display = 'flex';
}

setTimeout(() => {


  updateCustomSliders()
  const sliders = document.querySelectorAll('.usf-c-slider');

  sliders.forEach(slider => {
    const handleMin = slider.querySelector('.usf-c-slider__handle-min');
    const handleMax = slider.querySelector('.usf-c-slider__handle-max');
    const activeTrack = slider.querySelector('.usf-active');

    const parent = slider.closest('.usf-facet-range');
    const inputMin = parent.querySelector('.usf-slider-input__from input');
    const inputMax = parent.querySelector('.usf-slider-input__to input');

    const pipEls = slider.querySelectorAll('.usf-c-slider__pip .usf-slider-pip__value');
    const MIN_VALUE = parseInt(pipEls[0]?.innerText || '0', 10);
    const MAX_VALUE = parseInt(pipEls[pipEls.length - 1]?.innerText || '100', 10);

    let dragging = null;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function percentToValue(percent) {
      return Math.round(MIN_VALUE + (percent / 100) * (MAX_VALUE - MIN_VALUE));
    }

    function valueToPercent(value) {
      return ((value - MIN_VALUE) / (MAX_VALUE - MIN_VALUE)) * 100;
    }

    function updateSlider() {
      const minPercent = parseFloat(handleMin.style.left);
      const maxPercent = parseFloat(handleMax.style.left);
      const left = Math.min(minPercent, maxPercent);
      const right = Math.max(minPercent, maxPercent);

      activeTrack.style.left = `${left}%`;
      activeTrack.style.width = `${right - left}%`;

      inputMin.value = percentToValue(left);
      inputMax.value = percentToValue(right);

      updateFilterRange(inputMin, inputMax, slider)
    }

    function onMouseMove(e) {
      if (!dragging) return;
      const sliderRect = slider.getBoundingClientRect();
      let x = e.clientX - sliderRect.left;
      let percent = (x / sliderRect.width) * 100;
      percent = clamp(percent, 0, 100);

      dragging.style.left = `${percent}%`;
      updateSlider();
    }

    function onMouseUp() {
      dragging = null;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);

      if (window.innerWidth > 767) applyAjaxFilters();
    }

    function attachDrag(handle) {
      handle.addEventListener('mousedown', (e) => {
        dragging = handle;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        e.preventDefault();
      });
    }

    function updateHandleFromInput() {
      const minValue = clamp(parseInt(inputMin.value) || MIN_VALUE, MIN_VALUE, MAX_VALUE);
      const maxValue = clamp(parseInt(inputMax.value) || MAX_VALUE, MIN_VALUE, MAX_VALUE);

      const minPercent = clamp(valueToPercent(minValue), 0, 100);
      const maxPercent = clamp(valueToPercent(maxValue), 0, 100);

      handleMin.style.left = `${Math.min(minPercent, maxPercent)}%`;
      handleMax.style.left = `${Math.max(minPercent, maxPercent)}%`;

      updateSlider();
    }

    // Attach drag logic
    attachDrag(handleMin);
    attachDrag(handleMax);

    // Input sync
    inputMin.addEventListener('input', updateHandleFromInput);
    inputMax.addEventListener('input', updateHandleFromInput);

    // Initialize
    updateHandleFromInput();
  });

  // ✅ Sort Dropdown
  const sortBtn = document.querySelector('.sort-dropdown__selected');
  const sortListWrapper = document.querySelector('.sort-dropdown__list-wrapper');
  const sortOptions = document.querySelectorAll('.sort-dropdown__option');

  if (sortBtn && sortListWrapper) {
    sortBtn.addEventListener('click', () => {
      const isHidden = sortListWrapper.getAttribute('aria-hidden') === 'true';
      sortListWrapper.setAttribute('aria-hidden', isHidden ? 'false' : 'true');
    });
  }

  sortOptions.forEach(option => {
    option.addEventListener('click', () => {
      sortOptions.forEach(opt => opt.classList.remove('is-selected'));
      option.classList.add('is-selected');
      sortBtn.textContent = option.textContent;
      sortListWrapper.setAttribute('aria-hidden', 'true');
      const selectedValue = option.getAttribute('data-value');
      console.log("Sort by:", selectedValue);
    });
  });

  document.addEventListener('click', function (e) {
    if (!sortBtn?.contains(e.target) && !sortListWrapper?.contains(e.target)) {
      sortListWrapper?.setAttribute('aria-hidden', 'true');
    }
  });


  const sortButtons1 = document.querySelectorAll('.collection_list .usf-c-select__input-value');

  sortButtons1.forEach((btn) => {
    const popupId = btn.dataset.popupId;
    if (!popupId) return;

    const popup = document.getElementById(popupId);
    if (!popup) return;

    const closeBtn = popup.querySelector('.usf-remove');
    btn.addEventListener('click', () => {
      popup.removeAttribute('aria-hidden');
    });
    closeBtn?.addEventListener('click', () => {
      popup.setAttribute('aria-hidden', 'true');
    });
    document.addEventListener('click', (e) => {
      if (
        !popup.contains(e.target) &&
        e.target !== btn
      ) {
        popup.setAttribute('aria-hidden', 'true');
      }
    });
  });


  // ✅ Grid/List View Toggle
  const gridButtons = document.querySelectorAll('[data-usf-view="grid-view"]');
  const listButtons = document.querySelectorAll('[data-usf-view="list-view"]');
  const productGrid = document.querySelector(".productgrid--items");

  function applyView(view) {
    if (!productGrid) return;
    const isGrid = view === "grid";
    productGrid.classList.toggle("usf-grid", isGrid);
    productGrid.classList.toggle("usf-list", !isGrid);
    updateActiveButtons(view);
    localStorage.setItem("usf_view", view);
  }

  function updateActiveButtons(view) {
    gridButtons.forEach(btn => btn.classList.toggle("usf-active", view === "grid"));
    listButtons.forEach(btn => btn.classList.toggle("usf-active", view === "list"));
  }

  const savedView = localStorage.getItem("usf_view") || "grid";
 // applyView(savedView);
  gridButtons.forEach(button => button.addEventListener("click", () => applyView("grid")));
  listButtons.forEach(button => button.addEventListener("click", () => applyView("list")));

  // ✅ Short Description Trimmer
  document.querySelectorAll('.product-card__dimensions').forEach(function (el) {
    const rawHTML = el.getAttribute('data-description');
    const decodedHTML = rawHTML
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = decodedHTML;

    let wordCount = 0;
    const limit = 20;
    let finalHTML = "";

    function walk(node) {
      if (wordCount >= limit) return;
      if (node.nodeType === Node.TEXT_NODE) {
        const words = node.textContent.trim().split(/\s+/);
        const remaining = limit - wordCount;
        finalHTML += words.slice(0, remaining).join(" ") + " ";
        wordCount += words.length;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        finalHTML += `<${node.nodeName.toLowerCase()}`;
        for (let attr of node.attributes) {
          finalHTML += ` ${attr.name}="${attr.value}"`;
        }
        finalHTML += ">";
        node.childNodes.forEach(walk);
        finalHTML += `</${node.nodeName.toLowerCase()}>`;
      }
    }

    tempDiv.childNodes.forEach(walk);
    el.innerHTML = finalHTML.trim();
  });


  // ✅ AJAX Filters (FacetFiltersForm & SortByForm)
  const filterForm = document.getElementById("FacetFiltersForm");
  const sortForm = document.getElementById("SortByForm");
  const sortInput = document.getElementById("SortByInput");

  // ✅ Sorting options
  const selectedBtn = sortForm?.querySelector('.sort-dropdown__selected');
  const optionsWrapper = sortForm?.querySelector('.sort-dropdown__list-wrapper');
  const sortButtons = sortForm?.querySelectorAll('.sort-dropdown__option') || [];

  selectedBtn?.addEventListener('click', () => {
    optionsWrapper.style.display = optionsWrapper.style.display === 'none' ? 'block' : 'none';
  });

  sortButtons.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const val = btn.getAttribute('data-value');
      if (sortInput) {
        sortInput.value = val;
        applyAjaxFilters();
      }
      selectedBtn.innerText = btn.innerText;
      optionsWrapper.style.display = 'none';
      sortButtons.forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
    });
  });

  // ✅ Range Facets - sliders
  // Code here (skip for brevity if already optimized)

  // ✅ Clear all filters
  const clearAllBtn = document.querySelector('.usf-clear-all');
  clearAllBtn?.addEventListener('click', e => {
    e.preventDefault();
    window.location.href = window.location.pathname;
  });

  // ✅ Search inside facet filter
  function bindAllSearchBoxes() {
    document.querySelectorAll(".usf-search-box").forEach(searchInput => {
      const facetContainer = searchInput.closest(".usf-container");
      const facetLabels = facetContainer?.querySelectorAll(".usf-facet-value-multiple") || [];

      searchInput.addEventListener("input", function () {
        const value = this.value.toLowerCase().trim();
        let found = false;
        facetLabels.forEach(label => {
          const match = label.textContent.toLowerCase().includes(value);
          if (match && !found && value !== "") {
            label.style.display = "block";
            found = true;
          } else {
            label.style.display = value === "" ? "" : "none";
          }
        });
      });
    });
  }
  bindAllSearchBoxes();
  new MutationObserver(bindAllSearchBoxes).observe(document.body, { childList: true, subtree: true });

  if (localStorage.getItem("usf_view")) {
   // document.querySelector("[data-usf-view=" + localStorage.getItem("usf_view") + "-view" + "]").click()
  }

  // ✅ Additional Facet Filter Form (FacetFiltersForm2)
  // ...same logic as FacetFiltersForm

  if (document.querySelector(".js-load-more") != null) {
    document.querySelector(".js-load-more").addEventListener("click", function () {
      var $this = this,
        totalPages = parseInt(document.querySelector("[data-total-pages]").value),
        currentPage = parseInt(document.querySelector("[data-current-page]").value);
      newpage = currentPage + 1;
      $this.setAttribute("disabled", true);
      $this.querySelector("[load-more-text]").innerHTML = "Loading...";
      // $this.querySelector("[loader]").classList.remove("hide");
      var nextUrl = document.querySelector("[data-next-url]").value.replace(/page=[0-9]+/, 'page=' + newpage);


      fetch(nextUrl).then(function (response) {
        // The API call was successful!
        return response.text();

      }).then(function (html) {
        // This is the JSON from our response
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var oldhtml = document.querySelector("#product-grid").innerHTML;
        document.querySelector("#product-grid").innerHTML = oldhtml + doc.querySelector("#product-grid").innerHTML;
        if (currentPage < totalPages) {
          document.querySelector("[data-current-page]").value = newpage;
          $this.removeAttribute("disabled");
          $this.querySelector("[load-more-text]").innerHTML = "Load More";
          var newtotal = parseInt(document.querySelector(".total_products_showing").getAttribute("data-showing")) * newpage;
          document.querySelector(".total_products_showing").textContent =
            parseInt(document.querySelector(".total_all_products").textContent) > newtotal ? newtotal : parseInt(document.querySelector(".total_all_products").textContent);
          // $this.querySelector("[loader]").classList.add("hide");
        }
        else {
          document.querySelector(".loadmore").style.display = "none";
        }
      }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
      });
    })
  }




  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
  if (isMobile()) {
    document.body.classList.add('usf-mobile');
  } else {
    document.body.classList.remove('usf-mobile');
  }

  window.load = true;

}, 1000);
